import React, { useState, useEffect, forwardRef } from "react";
import { loadStripe, Stripe } from "@stripe/stripe-js";

import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.STRIPE);

const key = (window as any).stripePublishableKey;
const stripePromise = key ? loadStripe(key) : Promise.resolve(null);

type InjectedProps = { stripe: Stripe };
type WrapperProps<T extends React.ComponentType<any>> = Omit<React.ComponentProps<T>, keyof InjectedProps> & Partial<InjectedProps>;

export default function withStripe<T extends React.ComponentType<any>>(Component: T) {
    return forwardRef<T, WrapperProps<T>>(function ComponentWithStripe(props, componentRef) {
        if (props.stripe) {
            // Already passed
            // @ts-ignore
            return <Component {...props} ref={componentRef} />;
        }

        const [stripe, setStripe] = useState<Stripe | null>(null);

        useEffect(() => {
            stripePromise
                .then(stripe => setStripe(stripe))
                .catch(err => logger.error(err, "withStripe() failed to load Stripe.js"));
        }, []);

        if (!stripe) {
            return null;
        }

        // @ts-ignore
        return <Component {...props} stripe={stripe} ref={componentRef} />;
    });
}
